import { getThingsDone } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

export const GetThingsDoneSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='get-things-done-slide'>
                <img alt='' src={getThingsDone} />
            </div>
        </div>
    );
};

export const GetThingsDoneSlideImageSrc = getThingsDone;

interface Props {
    localization: ILocalization;
}

export const GetThingsDoneSlideContent = ({ localization }: Props) => {
    const { getThingsDoneSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial.user
            .slides;

    return (
        <div data-testid='second-slide' className='tutorial-content-wrapper'>
            <h1>{getThingsDoneSlide.howIGetThings}​​</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {getThingsDoneSlide.iKeepTrack}{' '}
                    <span className='instruction-content-bold'>
                        {getThingsDoneSlide.timelines}
                    </span>
                    <div />
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {getThingsDoneSlide.aTimelineConsistsOf}{' '}
                    <span className='instruction-content-bold'>
                        {getThingsDoneSlide.registration}
                    </span>
                    ,{' '}
                    <span className='instruction-content-bold'>
                        {getThingsDoneSlide.submission}{' '}
                    </span>{' '}
                    {getThingsDoneSlide.and}{' '}
                    <span className='instruction-content-bold'>
                        {getThingsDoneSlide.gradingPeriod}
                    </span>{' '}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {getThingsDoneSlide.eachPeriod}
                </div>
            </div>
        </div>
    );
};
